import React from 'react';
import classes from './RefreshButton.module.scss';

const RefreshButton = ({ onClick, isFetching = false, ariaLabel = 'Refresh', customClass }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    className={
      classes.Button +
      (isFetching ? ' ' + classes.Loading : '') +
      (customClass ? ' ' + customClass : '')
    }
  >
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 20c-2.233 0-4.125-.775-5.675-2.325C4.775 16.125 4 14.233 4 12c0-2.233.775-4.125 2.325-5.675C7.875 4.775 9.767 4 12 4c1.15 0 2.25.237 3.3.713A7.623 7.623 0 0 1 18 6.75V4h2v7h-7V9h4.2a5.836 5.836 0 0 0-2.188-2.2A5.928 5.928 0 0 0 12 6c-1.667 0-3.083.583-4.25 1.75C6.583 8.917 6 10.333 6 12c0 1.667.583 3.083 1.75 4.25C8.917 17.417 10.333 18 12 18a5.863 5.863 0 0 0 3.475-1.1A5.81 5.81 0 0 0 17.65 14h2.1c-.467 1.767-1.417 3.208-2.85 4.325S13.833 20 12 20Z"
      />
    </svg>
  </button>
);

export default React.memo(RefreshButton);
